<template>
  <!-- 人才服务标题 -->
  <div class="talentTitle">
    <div class="mainTitle">
      {{ title }}
      <slot name="subTitle">
      </slot>
    </div>
    <slot name="btn"></slot>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    title: String
  },
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>
<style lang="less" scoped>
.talentTitle {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: baseline;
  padding: 4px 10px;

  .mainTitle {
    font-size: 24px;
    font-weight: 600;
    color: #000;
    display: flex;
    flex-flow: row nowrap;
    justify-content: start;
    align-items: baseline;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/talentServices/talentTitle.vue